import { createSlice } from '@reduxjs/toolkit';

const skillSlice = createSlice({
    name: 'skills',
    initialState: [],
    reducers: {
        getSkill() { },
        getSkills() { },
        setSkill(state, action) {
            const { skill } = action.payload;
            const index = state.findIndex(s => s._id === skill._id);
            if (index !== -1) {
                state[index] = skill;
            } else {
                state.push(skill);
            }
            return state;
        },
        setSkills(state, action) {
            state = action.payload.skills;
            return state;
        },
        deleteSkill(state, action) {
            const { skillId } = action.payload;
            state = state.filter(skill => skill._id !== skillId);
            return state;
        },
        createSkill() { },
        editSkill() { },
        removeSkill() { },
        getSkillRates() { },
        getSkillUsage() { },
        saveSkillRates() { }
    },
});

export const { getSkill, getSkills, setSkill, setSkills, deleteSkill, createSkill, editSkill, removeSkill, getSkillRates, getSkillUsage, saveSkillRates } = skillSlice.actions;
export default skillSlice.reducer;
